import { EonUiIcon } from "@eon-ui/eon-ui-components-react";
import { ThemedIcon } from "@me8eon/icons";

const OnboardingPortalAppIcon = ({
    icon,
    iconUrl,
}: {
    icon?: string;
    iconUrl?: string;
}) => {
    if (icon) {
        if (icon?.endsWith(".svg")) {
            const iconName = icon.split(".")[0];
            let tempName = iconName === "notification" ? "tools" : iconName;
            return <ThemedIcon name={tempName} />;
        } else {
            return <EonUiIcon name={icon} />;
        }
    } else if (iconUrl) {
        return <img src={iconUrl} />;
    }
    return <></>;
};

export default OnboardingPortalAppIcon;